/* Endo predictive search: SKU-aware, keyboard-first, skeleton rows. */
(function () {
  var E = window.Endo || {}, R = E.routes || {}, S = E.strings || {};
  var root = document.querySelector('[data-search]');
  if (!root) return;
  var input = root.querySelector('[data-search-input]');
  var results = root.querySelector('[data-search-results]');
  var form = root.querySelector('[data-search-form]');
  var timer, ctrl, active = -1, lastQ = '';
  var RS_KEY = 'endo_rs';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(v) {
    if (v == null) return '';
    var fmt = E.money || '${{amount}}';
    var n = typeof v === 'number' ? v / 100 : parseFloat(String(v).replace(/[^0-9.]/g, ''));
    if (isNaN(n)) return '';
    var s = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, s).replace(/<[^>]+>/g, '');
  }
  function hl(text, q) {
    if (!q) return esc(text);
    var terms = q.trim().split(/\s+/).filter(Boolean).map(function (t) { return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!terms.length) return esc(text);
    return esc(text).replace(new RegExp('(' + terms.join('|') + ')', 'ig'), '<mark>$1</mark>');
  }
  function recent() { try { return JSON.parse(localStorage.getItem(RS_KEY) || '[]'); } catch (e) { return []; } }
  function remember(q) {
    q = q.trim(); if (!q) return;
    var r = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    r.unshift(q); try { localStorage.setItem(RS_KEY, JSON.stringify(r.slice(0, 6))); } catch (e) {}
    if (window.posthog && window.posthog.capture) window.posthog.capture('search', { query: q });
  }

  function open(prefill) {
    root.hidden = false; document.body.style.overflow = 'hidden';
    if (typeof prefill === 'string') input.value = prefill;
    input.focus(); query(input.value);
  }
  function close() { root.hidden = true; document.body.style.overflow = ''; }

  function skeleton() {
    var h = '<div class="search__group">';
    for (var i = 0; i < 4; i++) h += '<div class="sk-row"><span class="sk"></span><span><span class="sk sk--line" style="width:70%"></span><span class="sk sk--line" style="width:40%"></span></span><span class="sk sk--line" style="width:48px"></span></div>';
    results.innerHTML = h + '</div>';
  }

  function renderIdle() {
    var r = recent();
    if (!r.length) { results.innerHTML = '<div class="search__empty">' + esc(S.searchIdle || 'Type a part number, a bike, or a category.') + '</div>'; return; }
    var h = '<div class="search__group"><div class="search__group-title"><span class="eyebrow">' + esc(S.searchRecent || 'Recent searches') + '</span></div>';
    r.forEach(function (q) { h += '<a class="sr sr--recent" href="' + R.search + '?q=' + encodeURIComponent(q) + '&type=product" data-item data-fill="' + esc(q) + '"><svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg><span class="sr__title">' + esc(q) + '</span></a>'; });
    results.innerHTML = h + '</div>'; active = -1;
  }

  function render(data, q) {
    var res = (data && data.resources && data.resources.results) || {};
    var products = res.products || [], cols = res.collections || [];
    var fit = E.fitPrefix || 'fits:';
    var h = '';
    if (products.length) {
      h += '<div class="search__group"><div class="search__group-title"><span class="eyebrow">' + esc(S.searchParts || 'Parts') + '</span></div>';
      products.forEach(function (p) {
        var ql = q.toLowerCase();
        var v = (p.variants || []).find(function (x) { return x.sku && x.sku.toLowerCase().indexOf(ql) > -1; }) || (p.variants || [])[0] || {};
        var fits = (p.tags || []).filter(function (t) { return t.indexOf(fit) === 0; }).map(function (t) { return t.slice(fit.length).trim(); }).slice(0, 2).join(' / ');
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        h += '<a class="sr" href="' + esc(p.url) + '" data-item>' +
          (img ? '<img class="sr__img" src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="sr__img"></span>') +
          '<span><span class="sr__title">' + hl(p.title, q) + '</span><span class="sr__meta">' +
          (fits ? '<span>' + esc(fits) + '</span>' : '') +
          (p.available === false ? '<span>' + esc(E.strings.soldOut) + '</span>' : '') + '</span></span>' +
          '<span class="sr__price">' + money(p.price) + '</span></a>';
      });
      h += '</div>';
    }
    if (cols.length) {
      h += '<div class="search__group"><div class="search__group-title"><span class="eyebrow">' + esc(S.searchCollections || 'Collections') + '</span></div>';
      cols.forEach(function (c) {
        h += '<a class="sr sr--collection" href="' + esc(c.url) + '" data-item><span class="sr__icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"><path d="M3 12V4h8l9 9-8 8z"/><circle cx="7.5" cy="8.5" r="1.2"/></svg></span><span class="sr__title">' + hl(c.title, q) + '</span><svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"><path d="M5 12h14m-6-6 6 6-6 6"/></svg></a>';
      });
      h += '</div>';
    }
    if (!h) h = '<div class="search__empty">' + esc(S.searchNone || 'No parts match that.') + ' ' + esc(S.searchNoneHint || 'Check the part number or try the bike name.') + '</div>';
    h += '<div class="search__group"><a class="sr sr--all" href="' + R.search + '?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last" data-item><span>' + esc(S.searchSeeAll || 'See all results for') + ' "' + esc(q) + '"</span><svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"><path d="M5 12h14m-6-6 6 6-6 6"/></svg></a></div>';
    results.innerHTML = h; active = -1;
  }

  function query(q) {
    q = (q || '').trim();
    clearTimeout(timer);
    if (ctrl) ctrl.abort();
    if (!q) { lastQ = ''; renderIdle(); return; }
    if (q === lastQ) return;
    if (!results.querySelector('.sr')) skeleton();
    timer = setTimeout(function () {
      lastQ = q; ctrl = new AbortController();
      var url = R.predictive + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=8&resources[limit_scope]=each' +
        '&resources[options][fields]=title,product_type,variants.title,variants.sku,tag,vendor' +
        '&resources[options][unavailable_products]=last';
      fetch(url, { signal: ctrl.signal }).then(function (r) { return r.json(); }).then(function (d) { render(d, q); }).catch(function (e) { if (e.name !== 'AbortError') results.innerHTML = '<div class="search__empty">' + esc(S.searchUnavailable || 'Search is unavailable right now. Press Enter to search the full catalog.') + '</div>'; });
    }, 180);
  }

  function items() { return Array.prototype.slice.call(results.querySelectorAll('[data-item]')); }
  function setActive(i) {
    var list = items(); if (!list.length) return;
    active = (i + list.length) % list.length;
    list.forEach(function (el, k) { el.classList.toggle('is-active', k === active); });
    if (list[active].scrollIntoView) list[active].scrollIntoView({ block: 'nearest' });
  }

  input.addEventListener('input', function () { query(input.value); });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
    else if (e.key === 'Enter') {
      var list = items();
      if (active > -1 && list[active]) { e.preventDefault(); remember(input.value); var fill = list[active].getAttribute('data-fill'); if (fill) { input.value = fill; query(fill); active = -1; } else list[active].click(); }
      else if (!input.value.trim()) e.preventDefault();
      else remember(input.value);
    }
    else if (e.key === 'Escape') close();
  });
  results.addEventListener('click', function (e) {
    var a = e.target.closest('[data-item]'); if (!a) return;
    var fill = a.getAttribute('data-fill');
    if (fill) { e.preventDefault(); input.value = fill; query(fill); input.focus(); return; }
    remember(input.value);
  });
  form.addEventListener('submit', function () { remember(input.value); });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); open(); }
    else if (e.target.closest('[data-search-close]')) close();
  });
  var heroInput = document.querySelector('[data-search-open-input]');
  if (heroInput) {
    heroInput.addEventListener('focus', function () { open(heroInput.value); heroInput.blur(); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === '/' && !/input|textarea|select/i.test(document.activeElement.tagName) && root.hidden) { e.preventDefault(); open(); }
    if (e.key === 'Escape' && !root.hidden) close();
  });
})();
